__webpack_require__.p = "/odin/";